import { useState } from "react";
import { Modal } from "../../../BP2Components";
import FormV3Controller from "../FormV3Controller";
import "../formsV3.less";

interface FormV3InModalProps {
   formId: string;
   dataId?: string;
   saveCallback?: () => void;
   printable?: boolean;
   isOpen: boolean;
   setIsOpen: (value: boolean) => void;
   disabledFields?: boolean;
   pocData?: any;
   setPocData?: (val) => void;
}

export const FormV3InModal = ({
   dataId,
   formId,
   isOpen,
   saveCallback,
   setIsOpen,
   printable = false,
   pocData = {},
   setPocData,
}: FormV3InModalProps) => {
   const [header, setHeader] = useState<string>("");

   const closeModal = () => {
      setIsOpen(false);
      setPocData?.({});
   };
   const isQuestionnaire =
      pocData?.type?.module === "surveys" && pocData?.type?.name === "Questionnaire";
   return (
      <Modal isOpen={isOpen} onCancel={closeModal} topBarContent={header}>
         <FormV3Controller
            formId={formId}
            dataId={dataId}
            saveCallback={() => {
               saveCallback?.();
               closeModal();
            }}
            printable={printable}
            setHeader={setHeader}
            pocData={pocData}
            isQuestionnaire={isQuestionnaire}
         />
      </Modal>
   );
};
